<template>
  <InputGroup
    :bs="bs"
    :disabled="disabled || null"
    :readonly="readonly"
    :data-active="isFocus || null"
    v-bind="$attrs"
  >
    <template #custom>
      <BeerInputTag
        v-for="item of modelValue"
        :key="item"
        :readonly="readonly"
        :bs="tagBs"
        :disabled="disabled"
        @click:icon="() => removeItem(item)"
      >
        {{ item }}
      </BeerInputTag>
      <NewBsBox
        v-if="!(disabled || readonly)"
        :bs="{ 'cmp.inputGroup': 'flexInput' }"
        :placeholder="modelValue && modelValue.length > 0 ? '' : placeholder"
        as="input"
        type="text"
        @focus="() => isFocus = true"
        @blur="onBlur"
        @keydown="onKeydown"
      />
    </template>
  </InputGroup>
</template>

<script lang="ts">
  import {
    defineComponent, PropType,
  } from 'vue'
  import BeerInputTag from '@xhs/yam-beer/cmp/common/Tag/InputTag.vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import toaster from '@xhs/yam-beer/cmp/common/Toast/Toaster'
  import InputGroup from '../InputGroup/InputGroup.vue'
  import { BeerStyleObj } from '../../../core'

  /**
   * 连击输入框，通过回车或者失焦来添加值选项
   * @see 继承InputGroup #InputGroup
   */
  export default defineComponent({
    name: 'ComboInput',
    components: {
      InputGroup,
      BeerInputTag,
      NewBsBox,
    },
    inheritAttrs: false,
    props: {
      /**
       * @ignore
       * 容器BS
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 标签BS
       */
      tagBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 是否只读显示
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁止选
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       * 控制的值
       */
      modelValue: {
        type: Array as PropType<(string|number)[]>,
        default: () => [],
      },
      /**
       * @ignore
       */
      placeholder: {
        type: String,
        default: '请输入',
      },
      /**
       * 最多允许输入多少个选项
       */
      max: {
        type: Number,
        default: 5,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        isFocus: false,
      }
    },
    computed: {
      hasTags(): boolean {
        return this.modelValue && this.modelValue.length > 0
      },
    },
    methods: {
      onBlur(e: KeyboardEvent) {
        this.isFocus = false
        const el = e.target as HTMLInputElement
        const val = el.value.trim()
        this.addItem(el, val)
      },
      addItem(el: HTMLInputElement, val: string) {
        if (
          this.modelValue.indexOf(val) > -1
          || !val
        ) {
          return
        }
        if (this.modelValue.length >= this.max) {
          toaster.danger(`最多只允许输入 ${this.max} 个值`)
          return
        }
        const newV = this.modelValue.concat([val])

        this.$emit('update:modelValue', newV)
        // eslint-disable-next-line no-param-reassign
        el.value = ''
      },
      removeItem(item: string) {
        const newV = this.modelValue.filter(i => i !== item)
        this.$emit('update:modelValue', newV)
      },
      onKeydown(e: KeyboardEvent) {
        const el = e.target as HTMLInputElement
        const val = el.value.trim()
        if (e.key === 'Enter') {
          this.addItem(el, val)
        }
        if (e.key === 'Backspace'
          && !(e.target as HTMLInputElement).value
          && this.modelValue.length > 0
        ) {
          const newDeleteV = this.modelValue
            .filter((i, index) => index < this.modelValue.length - 1)
          this.$emit('update:modelValue', newDeleteV)
        }
      },
    },
  })
</script>
